import { render, staticRenderFns } from "./OrderNotesModal.vue?vue&type=template&id=7652a84e&scoped=true&"
import script from "./OrderNotesModal.vue?vue&type=script&lang=js&"
export * from "./OrderNotesModal.vue?vue&type=script&lang=js&"
import style0 from "../../styles/order-notes-modal.css?vue&type=style&index=0&id=7652a84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7652a84e",
  null
  
)

export default component.exports